import { delay } from 'redux-saga'
import {
  select,
  fork,
  put,
  all,
  call,
  take,
  takeLatest,
  takeEvery,
  cancelled,
} from 'redux-saga/effects'
import T from 'i18n-react'
import {
  post,
  getRequest
} from 'helpers/RequestUtil'

import {
  POST_FORMECID
} from './constants'

import {
  error,
  success
} from 'containers/App/Notification/actions'

import {
  licenseSelector,
  textSelector,
} from './selectors'

import {
  postFormEcidStart,
  postFormEcidSuccess
} from './actions'

import {
  projectIdSelector
} from 'containers/Project/View/selectors'

function* postForms() {
  try {    
    yield put(postFormEcidStart())
    const id = yield select(projectIdSelector)
    const text = yield select(textSelector)
    const license = yield select(licenseSelector)
    const postRequest = post('hulk', {text, id, license})
    yield call(postRequest, `/api/fulcrum/projects/${id}/hulk`)
    yield put(postFormEcidSuccess())
    yield put(success(T.translate(
      'pages.project.hulk.dialog.post_hulk_success'
    )))
  } catch(e) {
    yield put(error(T.translate('pages.project.hulk.dialog.post_hulk_error')))
  }
}

function* watchPostForms(){
  yield takeLatest(POST_FORMECID, postForms)
}

function* loadSagas() {
  yield all([
    fork(watchPostForms)
  ])
}

export default loadSagas
